import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import {
  getPOSCode,
  getUserPermissions,
  isVendorAdmin,
} from "../services/helper";
import Loader from "../Layout/Loader";

export default function PrivateRoutes() {
  const login = JSON.parse(localStorage.getItem("tealbo_vendor")!) || false;
  const permissions = getUserPermissions();
  const pos_code = getPOSCode();
  const location = useLocation();
  const is_vendor_admin = isVendorAdmin();

  const [isAllowed, setIsAllowed] = useState<boolean | null>(null); // null = pending
  const [deniedPath, setDeniedPath] = useState<string | null>(null);

  useEffect(() => {
    if (!login) return;

    // ✅ Skip all checks for vendor admins
    if (is_vendor_admin) {
      setIsAllowed(true);
      return;
    }

    const pathKey = location.pathname.replace(/^\//, "").replace(/-/g, "_");

    // If already denied and redirected, skip prompt
    if (deniedPath === location.pathname) {
      setIsAllowed(false);
      return;
    }

    if (permissions?.[pathKey] || pathKey === "pos") {
      setIsAllowed(true);
    } else {
      Swal.fire({
        title: "Enter POS Code",
        input: "password",
        inputLabel: "Permission required",
        inputPlaceholder: "Enter your POS code",
        inputAttributes: {
          maxlength: "20",
          autocapitalize: "off",
          autocorrect: "off",
        },
        confirmButtonText: "Submit",
        showCancelButton: true,
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed && result.value === pos_code) {
          setIsAllowed(true);
        } else {
          Swal.fire({
            icon: "error",
            title: "Access Denied",
            text: "Invalid POS Code or permission not granted.",
          });
          setDeniedPath(location.pathname);
          setIsAllowed(false);
        }
      });
    }
  }, [
    login,
    location.pathname,
    permissions,
    pos_code,
    deniedPath,
    is_vendor_admin,
  ]);

  if (!login) {
    return <Navigate to={`${process.env.PUBLIC_URL}/login`} />;
  }

  if (isAllowed === null) {
    return <Loader />;
  }

  return isAllowed ? (
    <Outlet />
  ) : (
    <Navigate to={`${process.env.PUBLIC_URL}/pos`} />
  );
}
